module.exports = __webpack_public_path__ + "img/real-estate-action-building-add.fe59e8ca.svg";